'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$GetProviderRequest(email) {
  this.Zd = null;
  this.Zd = email;
}
export { $c_Lpresto_types$proto$GetProviderRequest as $c_Lpresto_types$proto$GetProviderRequest };
$p = $c_Lpresto_types$proto$GetProviderRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$GetProviderRequest;
/** @constructor */
function $h_Lpresto_types$proto$GetProviderRequest() {
}
export { $h_Lpresto_types$proto$GetProviderRequest as $h_Lpresto_types$proto$GetProviderRequest };
$h_Lpresto_types$proto$GetProviderRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$GetProviderRequest) && (this.Zd === x$0.Zd)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "GetProviderRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Zd;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$GetProviderRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ld)));
}
export { $isArrayOf_Lpresto_types$proto$GetProviderRequest as $isArrayOf_Lpresto_types$proto$GetProviderRequest };
var $d_Lpresto_types$proto$GetProviderRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$GetProviderRequest, "presto.types$proto$GetProviderRequest", ({
  ld: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$GetProviderRequest as $d_Lpresto_types$proto$GetProviderRequest };
//# sourceMappingURL=presto.types$proto$-Get-Provider-Request.js.map
